import { faIR } from "date-fns/locale";
import * as React from "react";
import { useEffect, useState } from "react";
import { Animated } from "react-animated-css";
import { ButtonToolbar, Dropdown, DropdownButton } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader
} from "../../../_metronic/_partials/controls/Card";
import * as Api from "../../General/api";
import * as Common from "../../General/common";
export default function CloseWound(props) {
  const [orderListUI, setOrderListUI] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {

    getAllResidentCloseWound();

  }, []);
  const getAllResidentCloseWound = () => {
    
    // Api.getRequestQry(Api.Uri_GetFacilityResidentWoundOrder, "?facilityID=" + props.facility.id + "&isApproved=" + 2)
    Api.getRequestQry(Api.URI_GetResidentWoundByResidentID, "?id=" + props.resident.id + "&woundId=" + 0 + "&isOpen=" + 0+ "&isCycleCompleted=" + 2)
      .then((res) => {
        if (res.data.statusCode == 200) {
          // setOrderListUI([]);
          setOrderListUI([]);
          if (res.data.result != null) {
            if (res.data.result.length > 0) {
              setFacilityList(res.data.result);
            }
          }
        }
      })
      .catch((ex) => {
        Common.LogError(ex, "Workqueue", "getAllFacility");


      })
      .then(() => {
        setIsLoading(false);

      });
  };
  const handleResidentWoundStatus = (obj) => {
    let tempObj = JSON.parse(JSON.stringify(obj));
    tempObj.wound.isOpen = tempObj.wound.isOpen == true ? false : true;
    updateResidentWoundStatus(tempObj);
  };
  const updateResidentWoundStatus = (obj) => {
    var msg = "You want to " + (obj.wound.isOpen ? "Open" : "Close") + " Wound.";
    Common.showConfirmation(msg, "", updateWoundStatus, null, obj)

  };
  const updateWoundStatus = (obj) => {
    if (obj) {
      setIsLoading(true)
      Api.postRequest(Api.apiUrls.updateResidentWoundStatus, obj).then((res) => {
        if (res.data.success) {
          props.close();
          getAllResidentCloseWound();
          Common.showSuccessAlertAutoClose("Wound Status Updated Successfully", "success", "Success!", 3000)
          setIsLoading(false)
        } else {
          Common.showSuccessAlert(res.data.message, "error", "Error!", 3000);
          setIsLoading(false)
        }
      });
    }
  }
  const setFacilityList = (list) => {

    var rows = [];
    for (var i = 0; i < list.length; i++) {
      let obj = JSON.parse(JSON.stringify(list[i]));
      
      var dateFirstObserved = new Date(obj.dateFirstObserved);
      rows.push(
        <React.Fragment key={i}>
          <tr>
            <th>Num</th>
            <th>Body Region/Wound Location</th>
            <th>{obj.wound.fkWoundTypeId == Common.WoundType.pressure ? 'Stage/Thickness'
              : obj.wound.fkWoundTypeId == Common.WoundType.Surgical || obj.wound.fkWoundTypeId == Common.WoundType.tubeSize ? 'Stage/Thickness' : 'Thickness/Most Severe Tissue'}</th>

            <th>ICD10 Code</th>
            <th>Wound Size</th>
            <th>Evaluated on</th>
            <th>Evaluated By</th>
            <th>Actions</th>
          </tr>
          <tr >
            <td className="justify-content-center"> <b>{i + 1}</b> </td>
            <td>
              {obj.wound.orientationLeftRightName == null || obj.wound.orientationLeftRightName == "" ? "" : obj.wound.orientationLeftRightName + " - "}
              {Common.replaceNullWithString(obj.wound.bodyRegion)}{obj.residentWoundLocation != null ? "/" : ""}{Common.replaceNullWithString(obj.residentWoundLocation)}
              {obj.wound.orientation == null || obj.wound.orientation == "" ? "" : " - " + obj.wound.orientation}
            </td>
            <td>
              {Common.replaceNullWithString(obj.wound.woundThicknessName)}
              {obj.wound.fkWoundTypeId == Common.WoundType.pressure ||
                obj.wound.fkWoundTypeId == Common.WoundType.Surgical
                || obj.wound.fkWoundTypeId == Common.WoundType.tubeSize ? ' '
                : obj.wound.woundThicknessName != null && obj.wound.woundSevereTissueName != null ?
                  " - "
                  + (Common.replaceNullWithString(obj.wound.woundSevereTissueName))
                  : " "}

            </td>
            <td>{Common.replaceNullWithString(obj.wound.icdcode) != '' ? obj.wound.icdcode : 'N/A'}</td>
            <td >  {obj.wound.woundLength + " x " + obj.wound.woundWidth + " x " + obj.wound.woundDepth +" " +(obj.wound.isUtd == true?"U":"")}</td>
            <td>{Common.replaceNullWithString(obj.wound.evaluationDate) != '' ? Common.getInputStringDate(new Date(obj.wound.evaluationDate)) : 'N/A'}</td>
            <td>{Common.replaceNullWithString(obj.evaluatedBy) != '' ? obj.evaluatedBy : 'N/A'}</td>
            <td align="center">
              <>
                <ButtonToolbar className="justify-content-center">
                  <div className="mr-md-4 mr-0 mb-1 mb-md-0">
                    {[DropdownButton].map((DropdownType, idx) => (
                      <DropdownType
                        size="xs"
                        variant="primary"
                        title="Actions"
                        id={`dropdown-button-drop-${idx}`}
                      >

                        <Dropdown.Item eventKey="8" className="text-danger" onClick={() => handleResidentWoundStatus(obj)}>{obj.wound.isOpen ? 'Close Wound' : 'Open Wound'}</Dropdown.Item>


                      </DropdownType>
                    ))}
                  </div>
                </ButtonToolbar>
              </>
            </td>


          </tr>
        </React.Fragment>
      );
    }
    setOrderListUI(rows);
    Common.LoadDataTable("facilityTable");
  };



  return (
    <>

      <Animated animationIn="fadeIn" animationInDuration={1000}>
        <Card className="example example-compact">
          {/* <CardHeader  >
  
              <div className="card-title ">
                <span>
                  <h3 className="card-label">Resident Wounds</h3>
                </span>
              </div>
 
        </CardHeader> */}
          <CardBody>

            {isLoading ? (
              <div className="row d-flex justify-content-center">
                <span className="mt-5 spinner spinner-primary"></span>
              </div>
            ) : (
              <table
                className="table table-striped table-hover table-sm table-bordered"
                id="facilityTable"
              >
                {/* <thead>
                <tr>
                <th>Wound#</th>
                            <th>Body Region/Wound Location</th>
                            <th>Wound Type/Stage/Thickness</th>
                            <th>ICD10 Code</th>
                            <th>Wound Size</th>
                            <th>Evaluated on</th>
                            <th>Evaluated By</th>
                            <th>Actions</th>
                </tr>
              </thead> */}
                <tbody>{orderListUI}</tbody>
              </table>
            )}

          </CardBody>
        </Card>
      </Animated>
    </>
  )

}
